//frontend/src/applications/administrator/routes.jsx

import { Routes, Route } from "react-router-dom";
import DesktopPage from "../../components/DesktopPage/DesktopPage";
import CalendarPage from "../../components/CalendarPage/CalendarPage";
import MapPage from "../../components/MapPage/MapPage";
import FinanceReport from "../../components/FinanceReport/FinanceReport";
import ClientsPage from "../../components/ClientsPage/ClientsPage";
import SuppliersPage from "../../components/SuppliersPage/SuppliersPage";
import ProductsPage from "../../components/ProductsPage/ProductsPage";
import ExpeditorsPage from "../../components/ExpeditorsPage/ExpeditorsPage";
import OrdersPage from "../../components/OrdersPage/OrdersPage";
import TrackingPage from "../../components/TrackingPage/TrackingPage";
import HelpPage from "../../components/HelpPage/HelpPage";
import AccountingPage from "../../components/FinanceReport/Accounting/AccountingPage";
import PaymentDetailPage from "../../components/FinanceReport/Accounting/PaymentDetailPage";
import PaymentAllocationDetailPage from "../../components/FinanceReport/Accounting/our_allocations/PaymentAllocationDetailPage";
import UsersPage from "../../components/UsersPage/UsersPage";
import FinanceAccountPage from "../../components/FinanceReport/FinanceReportAccounts/FinanceAccountPage";
import ClientDetailPage from "../../components/ClientsPage/ClientDetailPage";
import SupplierDetail from "../../components/SuppliersPage/SupplierDetail";
import ProductDetailPage from "../../components/ProductsPage/ProductDetailPage";
import ClientProductsPage from "../../components/ClientProductsPage/ClientProductsPage";
import OrdersDetailPage from "../../components/OrdersPage/OrdersDetailPage";
import ProductOrderPage from "../../components/OrdersPage/ProductOrderPage/ProductOrderPage";
import OrderFinancesPage from "../../components/OrdersPage/OrderFinances/OrderFinancesPage";
import ExpensesOrderPage from "../../components/OrdersPage/ExpensesOrderPage/ExpensesOrderPage";
import ExpeditorDetailPage from "../../components/ExpeditorsPage/ExpeditorDetailPage";
import WarehousesPage from "../../components/ExpeditorsPage/WarehousesPage";
import OrderPhotosPage from "../../components/OrdersPage/OrderPhotosPage";
import OrderDocumentsPage from "../../components/OrdersPage/OrderDocumentsPage/OrderDocumentsPage";
import ClientBalancePage from "../../components/ClientsPage/ClientBalancePage";
import EcoCalculatorPage from "../../components/EcoCalculatorPage/EcoCalculatorPage";
import CompanyAccountDetailPage from "../../components/FinanceReport/Accounting/components/accounts/company-accounts/CompanyAccountDetailPage";
import SupplierAccountDetailPage from "../../components/FinanceReport/Accounting/components/accounts/suppliers/SupplierAccountDetailPage";
import AdminRequestsList from "../../components/AdminRequests/AdminRequestsList";
import AdminRequestDetail from "../../components/AdminRequests/AdminRequestDetail";

export default function AdministratorRoutes({
  selectedOrders = [],
  setSelectedOrders,
}) {
  return (
    <Routes>
      <Route path="/" element={<DesktopPage />} />

      <Route
        path="/calendar"
        element={
          <CalendarPage
            selectedOrders={selectedOrders}
            setSelectedOrders={setSelectedOrders}
          />
        }
      />

      <Route
        path="/map"
        element={
          <MapPage
            selectedOrders={selectedOrders}
            setSelectedOrders={setSelectedOrders}
          />
        }
      />

      <Route path="/finance" element={<FinanceReport />} />
      <Route path="/finance/accounts/:id" element={<FinanceAccountPage />} />

      <Route path="/clients" element={<ClientsPage />} />
      <Route path="/clients/:id" element={<ClientDetailPage />} />
      <Route path="/clients/:id/products" element={<ClientProductsPage />} />
      <Route path="/clients/:id/balance" element={<ClientBalancePage />} />

      <Route path="/suppliers" element={<SuppliersPage />} />
      <Route path="/suppliers/:id" element={<SupplierDetail />} />

      <Route path="/products" element={<ProductsPage />} />
      <Route path="/products/:id" element={<ProductDetailPage />} />

      <Route path="/expeditors" element={<ExpeditorsPage />} />
      <Route path="/expeditors/:id" element={<ExpeditorDetailPage />} />
      <Route
        path="/expeditors/:id/warehouses"
        element={<WarehousesPage />}
      />

      <Route
        path="/orders"
        element={
          <OrdersPage
            selectedOrders={selectedOrders}
            setSelectedOrders={setSelectedOrders}
          />
        }
      />
      <Route path="/orders/:id" element={<OrdersDetailPage />} />
      <Route path="/orders/:id/products" element={<ProductOrderPage />} />
      <Route path="/orders/:id/finances" element={<OrderFinancesPage />} />
      <Route path="/orders/:id/expenses" element={<ExpensesOrderPage />} />
      <Route path="/orders/:id/photos" element={<OrderPhotosPage />} />
      <Route path="/orders/:id/documents" element={<OrderDocumentsPage />} />

      <Route path="/tracking" element={<TrackingPage />} />
      <Route path="/help" element={<HelpPage />} />

      <Route path="/accounting" element={<AccountingPage />} />

      {/* Specific BEFORE generic /accounting/:id */}
      <Route
        path="/accounting/company-accounts/:accountId"
        element={<CompanyAccountDetailPage />}
      />
      <Route
        path="/accounting/supplier-accounts/:supplierId"
        element={<SupplierAccountDetailPage />}
      />
      <Route
        path="/accounting/:id/allocations/:allocationId"
        element={<PaymentAllocationDetailPage />}
      />
      <Route path="/accounting/:id" element={<PaymentDetailPage />} />

      <Route path="/request-search" element={<AdminRequestsList />} />
      <Route path="/request-search/:id" element={<AdminRequestDetail />} />

      <Route
        path="/admin/eco-calculator"
        element={<EcoCalculatorPage />}
      />
      <Route path="/users" element={<UsersPage />} />
    </Routes>
  );
}